// libs
import { connect } from 'react-redux';

// components
import ImageGridGallery from './ImageGridGallery';

// store
import { fetchAllImagesFromCustomerReview as _fetchAllImagesFromCustomerReview } from 'shared/store/details/services';
import {
  getAllReviewImages,
  isReviewImagesFetching,
  isReviewImagesFetchingError,
  getTotalReviewImages,
  getLastImageFetchedKey,
} from 'shared/store/details/selectors';

const mapStateToProps = (state: any) => {
  return {
    imageList: getAllReviewImages(state),
    pageKey: getLastImageFetchedKey(state),
    isFetching: isReviewImagesFetching(state),
    isError: isReviewImagesFetchingError(state),
    totalCount: getTotalReviewImages(state),
  };
};

const mapDispatchToProps = {
  fetchAllImagesFromCustomerReview: _fetchAllImagesFromCustomerReview,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageGridGallery);
